@if (open) {
  <div class="cd-backdrop" (click)="!submitting && close()">
    <div
      class="cd rd"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="rd-title"
      (click)="$event.stopPropagation()">
      @if (done) {
        <h3 id="rd-title" class="cd-title">Thanks, we've received your report.</h3>
        <p class="cd-message">Our team will take a look.</p>
      } @else {
        <h3 id="rd-title" class="cd-title">Report this {{ target && 'commentId' in target ? 'comment' : 'post' }}</h3>
        <p class="cd-message">What's wrong with it?</p>

        <div class="rd-reasons" role="radiogroup" aria-label="Reason">
          @for (r of reasons; track r.value) {
            <label class="rd-reason">
              <input type="radio" name="report-reason" [value]="r.value" [checked]="reason === r.value" (change)="reason = r.value" />
              {{ r.label }}
            </label>
          }
        </div>

        <textarea
          class="rd-details"
          rows="2"
          maxlength="500"
          placeholder="Anything else we should know? (optional)"
          aria-label="Additional details"
          [(ngModel)]="details"></textarea>

        @if (error) {
          <p class="rd-error" role="alert">{{ error }}</p>
        }

        <div class="cd-actions">
          <button type="button" class="cd-cancel" #cancelButton [disabled]="submitting" (click)="close()">Cancel</button>
          <button type="button" class="cd-confirm rd-submit" [disabled]="submitting || !reason" (click)="submit()">
            {{ submitting ? 'Sending…' : 'Submit report' }}
          </button>
        </div>
      }
    </div>
  </div>
}
